import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMagicEdit"><Path d="M16.5 3.5L20.5 7.5L7.5 20.5H3.5V16.5L16.5 3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M5 5L4 7L2 8L4 9L5 11L6 9L8 8L6 7L5 5Z" fill="currentColor"/><Path d="M9 2L8.33333 3.33333L7 4L8.33333 4.66667L9 6L9.66667 4.66667L11 4L9.66667 3.33333L9 2Z" fill="currentColor"/><Path d="M18.5 15L17.6667 16.6667L16 17.5L17.6667 18.3333L18.5 20L19.3333 18.3333L21 17.5L19.3333 16.6667L18.5 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicEdit;
